import {useEffect, useState, useMemo} from 'react'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {KTSVG} from '../../../../../../../../_metronic/helpers'

import { useDLMSiteApplicationsListContext } from '../context/DLMSiteApplicationsListContext'
import { groupBy } from 'lodash'

const DLMSiteApplicationsListFilter = () => {
const {sites : data, state, updateState} = useDLMSiteApplicationsListContext()
const [status, setStatus] = useState<string | undefined>('');
const [appType, setAppType] = useState<string | undefined>('');

const { statuses } = useMemo(()=> {

  if (! (data && data.length > 0)) { 
    return { statuses: [] }        
  }

  const statuses = Object.keys(groupBy(data, 'state')).sort()

  return { statuses };

}, [data])

const resetData = () => {
  setStatus('');
  setAppType('');

  updateState({...state, filter: undefined})
}

const filterData = () => {
  updateState({
    ...state,
    filter: {state: status, type: appType},      
  })
}

useEffect(() => {
  MenuComponent.reinitialization()
}, [])  

return (
  <>
  <button
    type='button'
    className='btn btn-light-primary btn-sm me-3'
    data-kt-menu-trigger='click'
    data-kt-menu-placement='bottom-end'
  >
    <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
    Filter
  </button>
  <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
    <div className='px-7 py-5'>
      <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
      </div>

      <div className='separator border-gray-200'></div>        

      <div className='px-7 py-5' data-kt-dlminspection-table-filter='form'>


      <div className='mb-4'>
        <label className='form-label fs-7 fw-bold'>Status:</label>
        <select
          className='form-select form-select-solid fw-bolder form-select-sm'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          data-kt-dlmdoc-table-filter='state'
          data-hide-search='true'
          onChange={(e) => setStatus(e.target.value ? e.target.value : undefined)}
          value={status}
        >
          <option></option>
          { statuses.map( (val, idx) => 
          <option key={`status${idx}`} value={val}>{val}</option>
          )}                                    
        </select>
      </div>        

      <div className='d-flex justify-content-end'>
        <button
          type='button'
          onClick={resetData}
          className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
          data-kt-menu-dismiss='true'
          data-kt-dlminspection-table-filter='reset'
        >
          Reset
        </button>
        <button
          type='button'
          onClick={filterData}
          className='btn btn-primary fw-bold px-6'
          data-kt-menu-dismiss='true'
          data-kt-dlminspection-table-filter='filter'
        >
          Apply
        </button>
      </div>            
    </div>        
  </div>    
  </>
  )
}

export {DLMSiteApplicationsListFilter}
